import { useState, useEffect, useCallback } from "react";
import { customerMe } from "@/lib/api";

const TOKEN_KEY = "amwap_customer_token";
const EVT = "amwap-auth-changed";

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
  window.dispatchEvent(new Event(EVT));
};

export const useAuth = () => {
  const [token, setTok] = useState(getToken);
  const [user, setUser] = useState(null); // null = loading/unknown, false = signed out, object = signed in
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    const t = getToken();
    setTok(t);
    if (!t) { setUser(false); setReady(true); return; }
    try {
      const me = await customerMe(t);
      setUser(me);
    } catch {
      setToken("");
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    refresh();
    const sync = () => refresh();
    window.addEventListener(EVT, sync);
    return () => window.removeEventListener(EVT, sync);
  }, [refresh]);

  const login = (t, u) => { setToken(t); setUser(u); };
  const logout = () => { setToken(""); setUser(false); };

  return { token, user, ready, login, logout, refresh };
};
